<template>
  <div class="detail">
    <div class="title flex-center">
      <span class="text">{{detail.fieldName}}</span>
      <span>{{detail.groupName}}</span>
      <span class="text" style="text-align: right;">{{detail.name}}</span>
    </div>
    <div class="box">
      <div class="info flex-center" :class="{'reverse': !isHome}">
        <div class="name">{{ detail.homeTeamName}}</div>
        <div><van-icon name="sort" class="sort-icon" @click="reverseBMGameLiveScoreboard" /></div>
        <div class="name">{{ detail.awayTeamName}}</div>
      </div>
      <div v-if="fieldLiveRoomStatus === 0">
         <div class="btn" @click="startBMFieldGameWarmup">热身开始</div>
      </div>
      <div v-else-if="fieldLiveRoomStatus === 1">
        <div class="text">热身中</div>
        <div class="btn" @click="addBMGameLiveTag">比赛开始</div>
      </div>
      <div v-else>
        <div class="score-card flex-center" :class="{'reverse': !isHome}">
          <div class="min-card" @click="addBMGameLiveScore(1,'home')" v-longpress="openUpdateMinScore">
            <div class="card-box flex-center">
              <div class="card"></div>
              <div class="card"></div>
              <div class="card"></div>
            </div>
            <div class="number">
              <span v-if="homeAddScore === -1" style="font-family: '';font-size: 85px;">--</span>
              <span v-else-if="homeAddScore < 10">{{ '0' + homeAddScore }}</span>
              <span v-else>{{ homeAddScore }}</span>
            </div>
          </div>
          <div class="max-card" @click="showActionSheet = true" v-longpress="openUpdateMaxScore">
            <div class="card-box flex-center">
              <div class="card"></div>
              <div class="card"></div>
            </div>
            <div class="number flex-center" :class="{'reverse': !isHome}">
              <div>{{ detail.homeScore }}</div>
              <span class="link"></span>
              <div>{{ detail.awayScore }}</div>
            </div>
            <div class="chessboard">第{{ gameStage.seq }}局</div>
          </div>
          <div class="min-card" @click="addBMGameLiveScore(1,'away')" v-longpress="openUpdateMinScore">
            <div class="card-box flex-center">
              <div class="card"></div>
              <div class="card"></div>
              <div class="card"></div>
            </div>
            <div class="number">
              <span v-if="awayAddScore === -1" style="font-family: '';font-size: 85px;">--</span>
              <span v-else-if="awayAddScore < 10">{{ '0' + awayAddScore }}</span>
              <span v-else>{{ awayAddScore }}</span>
            </div>
          </div>
        </div>
        <div class="operate flex-center" :class="{'reverse': !isHome}">
          <div style="flex: 1;" class="column">
            <div class="add" :class="{'active': servingSide === 'home'}" @click="updateBMGameServingSide('home')">发球 <van-icon name="success" class="icon" v-if="servingSide === 'home'" /></div>
            <div class="revoke" v-if="homeAddScore > 0" @click="addBMGameLiveScore(-1,'home')">撤分</div>
          </div>
          <div style="width: 105px;"></div>
          <div  style="flex: 1;" class="column">
            <div class="add" :class="{'active': servingSide === 'away'}" @click="updateBMGameServingSide('away')">发球 <van-icon name="success" class="icon" v-if="servingSide === 'away'" /></div>
            <div class="revoke" v-if="awayAddScore > 0" @click="addBMGameLiveScore(-1,'away')">撤分</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 长按更新小比分 -->
    <van-popup v-model="showUpdateMinScore" position="bottom" :close-on-click-overlay="false">
      <div class="update-min-score">
        <div class="update-min-score-title flex-center">
          <div class="cancel" @click="showUpdateMinScore = false">取消</div>
          <div class="update-title">编辑局内小分</div>
          <div class="confirm" @click="updateMinScore">确定</div>
        </div>
        <div class="update-min-score-content flex-center" :class="{'reverse': !isHome}">
          <div>
            <div class="name">{{ detail.homeTeamName}}</div>
            <van-stepper v-model="minScoreObj.homeAddScore" :min="0" :max="99" />
          </div>
          <div>
            <div class="name">{{ detail.awayTeamName}}</div>
            <van-stepper v-model="minScoreObj.awayAddScore" :min="0" :max="99" />
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 操作 -->
     <van-action-sheet
        v-model="showActionSheet"
        :actions="actions"
        cancel-text="取消"
        description="选择操作"
        close-on-click-action
        @select="handleSelect"
      />
    <van-overlay :show="showOverlay">
      <div class="wrapper">
        <div class="content">
          <div class="item" @click="handleNextStage">进入下一局</div>
          <div class="item" @click="handleSelect({name: '结束比赛'})">结束比赛</div>
        </div>
      </div>
    </van-overlay>
     <van-popup v-model="showUpdateMaxScore" position="bottom" :close-on-click-overlay="false">
        <div class="update-min-score">
        <div class="update-min-score-title flex-center">
          <div class="cancel" @click="showUpdateMaxScore = false">取消</div>
          <div class="update-title">编辑比分</div>
          <div class="confirm" @click="updateMaxScore">确定</div>
        </div>
         <div class="title-max flex-center" :class="{'reverse': !isHome}">
            <div class="name">{{ detail.homeTeamName}}</div>
            <div class="name">{{ detail.awayTeamName}}</div>
         </div>
        <div class="update-min-score-content flex-center" v-for="item in gameStageList" :key="item.id" :class="{'reverse': !isHome}">
          <div>
            <van-stepper v-model="item.homeScore" :min="0" :max="99" />
          </div>
          <div style="font-size: 12px;color: #999;">第{{ item.seq }}局</div>
          <div>
            <van-stepper v-model="item.awayScore" :min="0" :max="99" />
          </div>
        </div>
      </div>
     </van-popup>
  </div>
</template>

<script>
import { getBMGameLiveStatus, startBMFieldGameWarmup,addBMGameLiveTag,addBMGameLiveScore,updateBMGameStageScore2,getBMFieldExistOtherGameLivePrepare,getBMGameStageList,updateBMGameStages,updateBMGameServingSide,closeBMFieldGameLiveRoom,reverseBMGameLiveScoreboard } from '@/api/match'
import Vue from 'vue';
import { Dialog, Toast, Popup,Stepper,ActionSheet,Overlay } from 'vant';

// 全局注册
Vue.use(Dialog).use(Toast).use(Popup).use(Stepper).use(ActionSheet).use(Overlay);
export default {
  data() {
    return {
      gameId: '',
      detail: {},
      // fieldLiveRoomStatus: 0,
      homeAddScore: -1,
      awayAddScore: -1,
      showUpdateMinScore: false,
      showUpdateMaxScore: false,
      minScoreObj: {
        homeAddScore: 0,
        awayAddScore: 0
      },
      gameStage: {},
      showActionSheet: false,
      actions: [
        { name: '结束本局',color: '#2B71E1' },
        { name: '结束比赛',color: '#CA2D2A' }
      ],
      showOverlay: false,
      gameStageList: [],
      servingSide: '',
      isHome: true
    };
  },
  // 计算属性
  computed: {
    fieldLiveRoomStatus() {
      if (!this.detail.clock || this.detail.clock.prepareDone == 0) return 0
      else if (this.detail.clock.status === 'readyToRun') return 1
      else if (this.detail.clock.status === 'running') return 2
      return 2
      // 
    }
  },
  mounted() {
    this.gameId = this.$route.query.gameId
    this.getBMGameLiveStatus()
  },
  methods: {
    reverseBMGameLiveScoreboard() {
      const isReverse = this.isHome ? 1 : 0
      reverseBMGameLiveScoreboard({ gameId: this.gameId,isReverse }).then(res => {
        if (res) {
          this.getBMGameLiveStatus()
        }
      })
    },
    getBMGameLiveStatus() {
      getBMGameLiveStatus({ gameId: this.gameId }).then(res => {
        console.log(res)
        this.detail = res.data
        const gameStage = this.detail.gameStage
        if (gameStage.status === 1) { 
          this.homeAddScore = -1
          this.awayAddScore = -1
        } else {
          this.homeAddScore = gameStage.homeScore
          this.awayAddScore = gameStage.awayScore
        }
        this.gameStage = gameStage
        this.servingSide = this.detail.servingSide
        this.isHome = this.detail.liveScoreboardIsReverse === 0 ? true : false
        if(this.detail.clock.status === 'halt'){
          this.showOverlay = true
        }
      })
    },
    // 热身开赛
    startBMFieldGameWarmup() {
      getBMFieldExistOtherGameLivePrepare({ fieldId: this.detail.fieldId, gameId: this.gameId }).then(res => {
        if(res){
          const { data } = res
          if(data.exist){
            Dialog.alert({
              title: '提示',
              message: '当前场地存在其他进行中的场次，请先结束相关比赛后再次尝试进入热身！',
              confirmButtonText: '返回赛程列表'
            }).then(() => {
              this.$router.back()
            })
          } else {
            Dialog.confirm({
              title: '提示',
              message: '热身开赛后，比赛将进入进行中状态，确定进入热身吗？'
            }).then(() => {
              startBMFieldGameWarmup({ gameId: this.gameId }).then(res => {
                if (res) {
                  this.getBMGameLiveStatus()
                }
              })
            })
          }
        }
      })
    },
    // 比赛开始
    addBMGameLiveTag() {
      const params = {
        gameId: this.gameId,
        updateScore: 1,
        eventType: 'begin',
        endUtcSeconds: -1,
        beginUtcSeconds: -1,
        utcSeconds: new Date().getTime() / 1000,
        fat: true
      }
      addBMGameLiveTag(params).then(res => {
        if (res) {
          this.getBMGameLiveStatus()
        }
      })
    },
    // 添加比分 撤销比分
    addBMGameLiveScore(score, type) {
      const params = {
        gameId: this.gameId
      }
      if(type === 'home'){
        const homeAddScore = score
        params.homeAddScore = homeAddScore
      } else {
        const awayAddScore = score
        params.awayAddScore = awayAddScore
      }
      addBMGameLiveScore(params).then(res => { 
        if (res) {
          this.getBMGameLiveStatus()
          Toast('比分修改成功！')
        }
      })
    },
    // 打开更新小比分
    openUpdateMinScore() {
      this.minScoreObj.homeAddScore = this.homeAddScore
      this.minScoreObj.awayAddScore = this.awayAddScore
      this.showUpdateMinScore = true
    },
    // 长按更新小比分
    updateMinScore() {
      const params = {
        id: this.gameStage.id,
        homeScore: this.minScoreObj.homeAddScore,
        awayScore: this.minScoreObj.awayAddScore
      }
      updateBMGameStageScore2(params).then(res => {
        if (res) {
          Toast('比分修改成功！')
          this.getBMGameLiveStatus()
          this.showUpdateMinScore = false
        }
      })
    },
    // 打开更新大比分
    openUpdateMaxScore() {
      getBMGameStageList({ gameId: this.gameId }).then(res => {
        if (res) {
          this.gameStageList = res.data.gameStages.filter(item => item.seq <= this.gameStage.seq)
          this.showUpdateMaxScore = true
        }
      })
    },
    // 长按更新大比分
    updateMaxScore() {
      const params = {
        gameId: this.gameId,
        stages: JSON.stringify(this.gameStageList)
      }
      updateBMGameStages(params).then(res => {
        if (res) {
          Toast('比分修改成功！')
          this.getBMGameLiveStatus()
          this.showUpdateMaxScore = false
        }
      })
    },
    handleSelect(item) {
      if (item.name === '结束本局') {
        if (this.homeAddScore === this.awayAddScore) { 
          Dialog({
            title: '提示',
            message: '当前局内小分为平分，不满足结束本局的条件!',
            confirmButtonText: '我知道了'
          }).then(() => {
            this.showActionSheet = false
          })
        } else {
          Dialog.confirm({
            title: '提示',
            message: '是否结束本局？该动作一旦提交将不可撤回!',
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(() => {
            // status=running, gameClockSeconds=enclosedSeconds+ now-lastActivateUtcSeconds
            // status!=running, gameClockSeconds=enclosedSeconds
            const clock = this.detail.clock
            const gameClockSeconds = clock.status === 'running' ? clock.enclosedSeconds + new Date().getTime() / 1000 - clock.lastActivateUtcSeconds : clock.enclosedSeconds
            const params = {
              gameId: this.gameId,
              updateScore: 1,
              eventType: 'pause',
              isSectionEnd: 1,
              endUtcSeconds: -1,
              beginUtcSeconds: -1,
              utcSeconds: new Date().getTime() / 1000,
              gameClockSeconds: gameClockSeconds,
              fat: true
            }
            addBMGameLiveTag(params).then(res => { 
              if (res) {
                this.getBMGameLiveStatus()
              }
            })
          })
        }
      } else if(item.name === '结束比赛'){
        Dialog.confirm({
          title: '提示',
          message: '是否要结束比赛？比赛一旦结束，将无法重新进入这场比赛的记分台进行操作',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          closeBMFieldGameLiveRoom({ gameId: this.gameId }).then(res => {
            if (res) {
              Dialog({
                title: '提示',
                message: '比赛已结束',
                confirmButtonText: '返回赛程列表'
              }).then(() => {
                this.$router.back()
              })
            }
          })
        })
      }
    },
    handleNextStage() {
      const clock = this.detail.clock
      const gameClockSeconds = clock.status === 'running' ? clock.enclosedSeconds + new Date().getTime() / 1000 - clock.lastActivateUtcSeconds : clock.enclosedSeconds
      const params = {
        gameId: this.gameId,
        updateScore: 1,
        eventType: "resume",
        isNewSection: 1,
        endUtcSeconds: -1,
        beginUtcSeconds: -1,
        utcSeconds: new Date().getTime() / 1000,
        gameClockSeconds: gameClockSeconds,
        fat: true
      }
      addBMGameLiveTag(params).then(res => {
        if (res) {
          this.getBMGameLiveStatus()
          this.showOverlay = false
        }
      })
    },
    updateBMGameServingSide(side) {
      let servingSide = side
      if(this.servingSide === side) {
        servingSide = ''
      }
      const params = {
        gameId: this.gameId,
        servingSide
      }
      updateBMGameServingSide(params).then(res => { 
        if (res) {
          this.getBMGameLiveStatus()
        }
      })
    }
  },
};
</script>

<style scoped lang="scss">
.detail{
  .title{
    font-size: 14px;
    height: 45px;
    padding: 0 12px;
    border-bottom: 5px solid #e4e7ed;
    .text{
      flex: 1;
    }
  }
  .box{
    padding: 12px;
    .btn{
      width: 70%;
      margin: 24px auto;
      border: 2px solid #266DE0;
      border-radius: 4px;
      color: #266DE0;
      text-align: center;
      font-weight: 500;
      height: 50px;
      line-height: 50px;
    }
    .text{
      text-align: center;
      color: #999;
    }
    .info{
      height: 60px;
      border-bottom: 2px solid #e4e7ed;
      margin-bottom: 24px;
      .name{
        flex: 1;
        font-size: 18px;
        color: #000;
        font-weight: 500;
        text-align: center;
      }
      .sort-icon{
        font-size: 22px;
        transform: rotate(90deg);
        color: #266DE0;
      }
      &.reverse{
        flex-direction: row-reverse;
      }
    }
    .score-card{
      align-items: flex-start;
      &.reverse{
        flex-direction: row-reverse;
      }
      .min-card{
        flex: 1;
        height: 150px;
        border: 1px solid #e4e7ed;
        border-radius: 10px;
        background-color: #000;
        position: relative;
        .number{
          color: #FFFD55;
          padding-top: 20px;
          box-sizing: border-box;
          font-size: 110px;
          font-weight: 600;
          text-align: center;
          font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif
        }
        
      }
      .max-card{
        width: 85px;
        height: 75px;
        border-radius: 10px;
        background-color: #000;
        margin: 0 10px;
        position: relative;
        .card-box{
          transform: scale(.8);
          padding: 0 6px;
          top: 5px;
        }
        .number{
          font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
          color: #fff;
          font-size: 56px;
          padding-top: 12px;
          text-align: center;
          font-weight: 600;
          div{
            flex: 1;
          }
          .link{
            width: 2px;
            height: 40px;
            background-color: #666;
          }
          &.reverse{
            flex-direction: row-reverse;
          }
        }
        .chessboard{
            text-align: center;
            margin-top: 24px;
          }
      }
      .card-box{
        position: absolute;
        top: 10px;
        left: 0px;
        width: 100%;
        box-sizing: border-box;
        padding: 0 12px;
      }
      .card{
        background-color: #fff;
        width: 24px;
        height: 14px;
        border-radius: 5px 5px 2px 2px;
        position: relative;
        &::after{
          content: '';
          position: absolute;
          width: 15px;
          height: 18px;
          background-color: #000;
          border: 1px solid #424242;
          top: -50%;
          left: 50%;
          transform: translate(-50%,-40%);
        }
      }
    }
    .operate{
      padding: 26px 0px;
      align-items: flex-start;
      &.reverse{
        flex-direction: row-reverse;
      }
      .column{
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .add{
        position: relative;
        width: 60px;
        height: 60px;
        border: 2px solid #D8D8D8;
        color: #D8D8D8;
        border-radius: 50%;
        text-align: center;
        line-height: 60px;
        .icon{
          position: absolute;
          bottom: 0px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 22px;
          color: #4BA037;
        }
      }
      .active{
        border-color: #4BA037;
        color: #4BA037;
      }
      .revoke{
        color: #fff;
        width: 100px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border-radius: 8px;
        background-color: #F29D39;
        margin-top: 12px;
      }
    }
  }

  .update-min-score{
    padding: 12px 16px;
    height: 300px;
    .update-min-score-title{
      height: 45px;
      font-size: 14px;
      border-bottom: 3px solid #e4e7ed;
      .update-title{
        flex: 1;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
      }
      .cancel{
        color: #999;
      }
      .confirm{
        color: #266DE0;
      }
    }
    .title-max{
      padding: 0 24px;
      text-align: center;
      margin-top: 12px;
      font-size: 14px;
      div{
        width: 92px;
      }
      &.reverse{
        flex-direction: row-reverse;
      }
    }
    .update-min-score-content{
      padding: 16px 24px;
      .name{
        text-align: center;
        margin-bottom: 12px;
        font-size: 14px;
      }
      &.reverse{
        flex-direction: row-reverse;
      }
    }
  }

  .wrapper{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .content{
      .item{
        width: 200px;
        margin: 24px auto;
        border: 2px solid #266DE0;
        border-radius: 4px;
        color: #266DE0;
        text-align: center;
        font-weight: 500;
        height: 50px;
        line-height: 50px;
        background-color: #fff;
      }
    }
  }
}
</style>
